/* eslint-disable no-console */
import { queueCartWrite } from '../api/cart';

export class CartSessionHandler {
  constructor(attributeNames = []) {
    this.sessionKey = 'sysCacheFlag_vX93';
    this.tabCountKey = 'runtimeState_4GHT';
    this.attributeNames = attributeNames;
  }

  init() {
    window.addEventListener('load', () => this.handleSiteOpen());
    window.addEventListener('beforeunload', () => this.handleTabClose());

    this.clearCartAttributes();
  }

  handleSiteOpen() {
    const sessionId = localStorage.getItem(this.sessionKey);
    const tabCount = sessionStorage.getItem(this.tabCountKey) || '0';

    // No clear here: init() already cleared on this page load, and a second one queued at window.load could land
    // after the cart drawer's checkout write and wipe `path`.
    if (!sessionId) {
      localStorage.setItem(this.sessionKey, String(Date.now()));
    }

    sessionStorage.setItem(this.tabCountKey, (parseInt(tabCount) + 1).toString());
  }

  handleTabClose() {
    let tabCount = sessionStorage.getItem(this.tabCountKey) || '0';
    tabCount = Math.max(0, parseInt(tabCount) - 1).toString();
    sessionStorage.setItem(this.tabCountKey, tabCount);

    if (tabCount === '0') {
      localStorage.removeItem(this.sessionKey);
    }
  }

  clearCartAttributes() {
    if (!this.attributeNames.length) return;

    const attributesToClear = this.attributeNames.reduce((acc, attr) => {
      acc[attr] = '';
      return acc;
    }, {});

    queueCartWrite(() => fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributesToClear })
    }).then((response) => response.json()))
      .then((data) => {
        const clearedAttributes = Object.keys(attributesToClear).reduce((acc, key) => {
          if (data.attributes && key in data.attributes) {
            acc[key] = data.attributes[key];
          }
          return acc;
        }, {});

        console.log('Cleared attributes:', clearedAttributes);
      })
      .catch((error) => console.error('Error clearing cart attributes:', error));
  }
}
